<template>
  <!-- 디자인 시스템: 필터 아이콘 버튼. 아이콘/점색/강조색 고정, active만 노출.
       v-menu의 activator로 쓸 수 있게 attrs/listeners 를 내부 v-btn 으로 포워딩. -->
  <v-badge :value="active" color="red" dot overlap :offset-x="12" :offset-y="12">
    <v-btn icon :color="active ? 'primary' : ''" v-bind="$attrs" v-on="$listeners">
      <v-icon>mdi-filter-variant</v-icon>
    </v-btn>
  </v-badge>
</template>

<script>
export default {
  name: "AppFilterIconButton",
  // activator가 넘기는 attrs/listeners를 badge가 아니라 내부 v-btn으로 전달
  inheritAttrs: false,
  props: {
    // 필터 활성 여부 → 빨간 점 + primary 강조색
    active: { type: Boolean, default: false },
  },
};
</script>
